import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FiMenu } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Dropy2 = () => {
  return (
    <Menu>
      <Menu.Button>
        <FiMenu className='h-10 w-10 my-auto lg:hidden ring-red-700' />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter='transition duration-100 ease-out'
        enterFrom='transform scale-95 opacity-0'
        enterTo='transform scale-100 opacity-100'
        leave='transition duration-75 ease-out'
        leaveFrom='transform scale-100 opacity-100'
        leaveTo='transform scale-95 opacity-0'>
        <Menu.Items className=' flex flex-column justify-center w-11/12 text-2xl flex-wrap text-center absolute left-1 right-1 mx-auto mt-16 rounded space-y-1  bg-gray-100 shadow font-assistant wowo zindexh growDown growUp'>
          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/'>
                בית
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/about'>
                אודותינו
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/energy-efficiency'>
                התייעלות אנרגטית
              </Link>
            )}
          </Menu.Item>

          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/energy-storage'>
                אגירת אנרגיה
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/funding'>
                מידע ומימון
              </Link>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/environment'>
                איכות הסביבה
              </Link>
            )}
          </Menu.Item>

          <Menu.Item>
            {({ active }) => (
              <Link className={`${active && 'bg-cyan-50 shadow'} h-9 w-full rounded`} to='/contact'>
                צרו קשר
              </Link>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default Dropy2;
